<div class="text-center">
  <i 
    class="pi" 
    [ngClass]="data.icon || 'pi-exclamation-triangle'" 
    style="font-size: 3rem; color: var(--color-danger-waste)">
  </i>
  
  <p style="font-size: 14px;" class="text-black mt-2">
    {{ data.message | translate }}
  </p>
  
  <br />

  <div class="flex justify-between p-[1rem]">
    <div class="w-[12rem]">
      <p-button
        [label]="(data.cancelLabel || 'shared_cancel') | translate"
        severity="danger"
        variant="outlined"
        styleClass="w-full"
        (onClick)="cancel()"
      />
    </div>

    <div class="w-[12rem]">
      <p-button
        [label]="(data.confirmLabel || 'shared_confirm') | translate"
        [severity]="data.confirmSeverity || 'primary'"
        styleClass="w-full font-medium"
        (onClick)="confirm()"
      />
    </div>
  </div>
</div>

